import Vue from 'vue'
import { formatDate } from './utils'

export const workScoreFilter = value => {
  if (value >= 0 && value < 10) {
    return 0
  } else if (value >= 10 && value < 20) {
    return 0.5
  } else if (value >= 20 && value < 30) {
    return 1
  } else if (value >= 30 && value < 40) {
    return 1.5
  } else if (value >= 40 && value < 50) {
    return 2
  } else if (value >= 50 && value < 60) {
    return 2.5
  } else if (value >= 60 && value < 70) {
    return 3
  } else if (value >= 70 && value < 80) {
    return 3.5
  } else if (value >= 80 && value < 90) {
    return 4
  } else if (value >= 90 && value < 100) {
    return 4.5
  } else if (value === 100) {
    return 5
  }
}

// 时间格式化
Vue.filter('date', formatDate)
